/**
 * Delt oppløsning av skannekrav (SPEC v2, TW 36344429).
 *
 * Profilinnstillingen er kundens "normal"; unntakene flagges på tingen som er unntaket:
 *   - Items.BarCodeConfirmItem     → overstyrer KUN vareskann-kravet
 *   - StcBin.BarCodeConfirmLocation → overstyrer KUN lokasjonsskann-kravet
 *
 * Tri-state: null/undefined = arv fra profil, true/false = overstyr (skjerpe eller lempe).
 * Brukes av både plukk (usePickingData) og vareplassering (ModernPutAwayDetails).
 */
export function resolveScanRequirement(
  overrideFlag: boolean | null | undefined,
  profileRequirement: boolean
): boolean {
  return overrideFlag ?? profileRequirement;
}
